import { dataAtom, dataComposer } from "@frend-digital/centra";

import type { CentraProduct } from "@/lib/centra/atomicSetup";

import { baseAtomics } from "../../atomicSetup";
const { getMediaBySize } = baseAtomics;

const getStandardMedia = (product: CentraProduct) =>
  getMediaBySize(product, "full");

export const getFirstThumbnail = (product: CentraProduct) => {
  const thumbnails = getStandardMedia(product);
  if (thumbnails?.[0]) return thumbnails[0];
  throw new Error("No thumbnails found");
};

export const getSecondThumbnail = (product: CentraProduct) => {
  const thumbnails = getStandardMedia(product);
  if (thumbnails?.[1]) return thumbnails[1];
  throw new Error("Second thumbnail not found");
};

const getProductGallery = (product: CentraProduct) => {
  if ("altImage" in product.media && "image" in product.media) {
    //! This is algolia data
    const getAlgoliaImage = (product: CentraProduct) => {
      const image = (product.media as any).image;
      return {
        href: image as string,
        alt: "",
      };
    };
    const getAlgoliaSecondImage = (product: CentraProduct) => {
      const image = (product.media as any).altImage;
      return {
        href: image as string,
        alt: "",
      };
    };
    return dataComposer({
      image: dataAtom(getAlgoliaImage, 2)(product),
      secondImage: dataAtom(getAlgoliaSecondImage, 2)(product),
    });
  }

  const image = dataAtom(getFirstThumbnail, 2)(product);
  const secondImage = dataAtom(getSecondThumbnail, 2)(product);

  const standardProductCardGallery = dataComposer({
    image,
    secondImage,
  });

  return standardProductCardGallery;
};

export default getProductGallery;
